/* eslint-disable */
/*eslint no-unused-vars: ["error", {"ards": "none"}]*/
<template>
  <!--###################### NAVBAR ##################### -->
  <div class="container-fluid nav-bar">
    <nav class="navbar navbar-expand-lg navbar-light">
      <router-link to="/" class="navbar-brand">
        <span class="orange">MB</span>Clothing
      </router-link>

      <router-link to="/cart" class="cart-link ml-auto p-1 text-dark text-decoration-none">
        <div class="card_count_div">
          <span
            v-if="cart.length"
            class="cart-price-total badge badge-primary"
          >{{ cartTotalQuantity }}</span>
          <i class="fa fa-cart-plus mx-1" aria-hidden="true"></i>
        </div>
      </router-link>
      <div class="margin_space">
        <span style="visibility: hidden;">000</span>
      </div>
      <button
        class="navbar-toggler mr-1"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse text-center" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link
              to="/"
              class="nav-link"
              data-toggle="collapse"
              data-target="#navbarNav"
              exact
            >Home</router-link>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="categories"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >New Arrivals</a>
            <div class="dropdown-menu" aria-labelledby="categories">
              <router-link
                :to="{ name: 'Categorylist', params: { id: 'Bags' } }"
                class="dropdown-item"
                data-toggle="collapse"
                data-target="#navbarNav"
              >Bags</router-link>
              <router-link
                :to="{ name: 'Categorylist', params: { id: 'Belt' } }"
                class="dropdown-item"
                data-toggle="collapse"
                data-target="#navbarNav"
              >Belts</router-link>
              <router-link
                :to="{ name: 'Categorylist', params: { id: 'Jeans' } }"
                class="dropdown-item"
                data-toggle="collapse"
                data-target="#navbarNav"
              >Jeans</router-link>
              <router-link
                :to="{ name: 'Categorylist', params: { id: 'Shoes' } }"
                class="dropdown-item"
                data-toggle="collapse"
                data-target="#navbarNav"
              >Shoes</router-link>
              <router-link
                :to="{ name: 'Categorylist', params: { id: 'T-shirt' } }"
                class="dropdown-item"
                data-toggle="collapse"
                data-target="#navbarNav"
              >T-Shirt</router-link>
              <router-link
                :to="{ name: 'Categorylist', params: { id: 'Kids' } }"
                class="dropdown-item"
                data-toggle="collapse"
                data-target="#navbarNav"
              >Kids wear</router-link>
            </div>
          </li>
          <li class="nav-item">
            <router-link
              to="/about"
              class="nav-link"
              data-toggle="collapse"
              data-target="#navbarNav"
            >About</router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/contact"
              class="nav-link"
              data-toggle="collapse"
              data-target="#navbarNav"
            >Contact</router-link>
          </li>
        </ul>
      </div>
      <transition name="fade">
        <form v-if="showSearch" @submit.prevent="processSearch()">
          <input
            type="search"
            class="form-control mr-sm-2"
            id="search_input"
            placeholder="search"
            aria-label="search"
            v-model="search"
          />
        </form>
      </transition>
      <span style="visibility: hidden;">00</span>
      <div class="search_icons">
        <i
          class="fa fa-search mx-1"
          @click="showSearchInput()"
          v-if="!showSearch"
          aria-hidden="true"
        ></i>
        <i class="fa fa-times mx-1" @click="hideSearchInput()" v-if="showSearch" aria-hidden="true"></i>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      search: ""
    };
  },
  computed: {
    cartCount() {
      return this.$store.state.cart.length;
    },
    cart() {
      return this.$store.state.cart;
    },
    cartTotalQuantity() {
      return this.$store.getters.cartTotalQuantity;
    },
    showSearch() {
      return this.$store.state.showSearch;
    }
  },

  methods: {
    showSearchInput: function() {
      this.$store.state.showSearch = true;
    },
    hideSearchInput: function() {
      this.$store.state.showSearch = false;
      this.search = "";
    },
    processSearch: function() {
      let searchProduct = this.search;
      if (!searchProduct) {
        return false;
      } else {
        this.$store.dispatch("getSearchResult", searchProduct);
        this.$store.state.searchName = this.search;

        this.$router.push("/search").catch(error => {
          if (error) {
            error;
            setTimeout(
              () => (this.$store.state.componentIsLoading = false),
              2000
            );
          }
        });
        this.search = "";
        this.$store.state.componentIsLoading = true;
        this.$store.state.componentIsSearching = true;
        this.$store.state.showSearch = false;
        return true;
      }
    }
  }
};
</script>

